import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewFeedListenerMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NewFeedListenerMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, student: { __typename?: 'Student', id: string } } | null };


export const NewFeedListenerMeDocument = gql`
    query NewFeedListenerMe {
  me {
    id
    student {
      id
    }
  }
}
    `;

/**
 * __useNewFeedListenerMeQuery__
 *
 * To run a query within a React component, call `useNewFeedListenerMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewFeedListenerMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewFeedListenerMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewFeedListenerMeQuery(baseOptions?: Apollo.QueryHookOptions<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>(NewFeedListenerMeDocument, options);
      }
export function useNewFeedListenerMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>(NewFeedListenerMeDocument, options);
        }
export function useNewFeedListenerMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>(NewFeedListenerMeDocument, options);
        }
export type NewFeedListenerMeQueryHookResult = ReturnType<typeof useNewFeedListenerMeQuery>;
export type NewFeedListenerMeLazyQueryHookResult = ReturnType<typeof useNewFeedListenerMeLazyQuery>;
export type NewFeedListenerMeSuspenseQueryHookResult = ReturnType<typeof useNewFeedListenerMeSuspenseQuery>;
export type NewFeedListenerMeQueryResult = Apollo.QueryResult<NewFeedListenerMeQuery, NewFeedListenerMeQueryVariables>;
export const namedOperations = {
  Query: {
    NewFeedListenerMe: 'NewFeedListenerMe'
  }
}